<template>
  <div class="all">
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="图表模式"
        placement="top"
        v-if="listColumn"
      >
        <div
          @click="changelistColumn()"
          class="cursorpointer margin-top10 margin-right10"
        >
          <img
            src="@/assets/barsvg/icon／14gd.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">图表模式</span>
        </div>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="列表模式"
        placement="top"
        v-if="picColumn"
      >
        <div @click="changepicColumn()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／14gd.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">列表模式</span>
        </div>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <div @click="showColumn()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12xsl.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
        </div>
      </el-tooltip>
    </div>

    <!-- 关键词检索  -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="100px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="产品名称">
          <el-input placeholder="请输入产品名称" v-model="input"></el-input>
        </el-form-item>
        <el-form-item label="技术关键词">
          <el-input placeholder="请输入技术关键词" v-model="inputs"></el-input>
        </el-form-item>
        <div class="margin-left20 margin-top10 margin-bot10">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()">重 置</el-button>
        </div>
      </el-form>
      <span
        class="attention margin-top10 margin-bot10 margin-left20 margin-right20"
        @click="dialogVisibleaddpro()"
        >新 增</span
      >
    </div>

    <!-- 表单 -->
    <el-skeleton
      class="width100 backwhite border-rd3 alldigital margin-top15"
      :loading="true"
      animated
      :throttle="500"
      v-if="listColumn"
    >
      <template slot="template">
        <el-table
          :data="pages"
          stripe
          class="eltable width98 margin-auto margin-top20 textalign-left f14"
          :columns="columns"
          v-if="total != 0"
        >
          <el-table-column
            label="产品名称"
            align="center"
            width="250px"
            v-if="columns[0].visible"
          >
            <template slot-scope="scope">
              <div
                class="cursorpointer bluecolor"
                @click="projectpreviews(scope.row)"
              >
                <span>{{ scope.row.title }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="产品大类"
            align="center"
            prop="bigcate.name"
            v-if="columns[1].visible"
          />
          <el-table-column
            label="产品小类"
            align="center"
            prop="cate.name"
            v-if="columns[2].visible"
          />
          <el-table-column
            label="技术关键词"
            align="center"
            prop="tech_keyword"
            v-if="columns[3].visible"
          />
          <el-table-column
            label="研发立项时间"
            align="center"
            prop="start_at"
            v-if="columns[4].visible"
          />
          <el-table-column
            label="上游产业"
            align="center"
            prop="upsteam"
            v-if="columns[5].visible"
          />
          <el-table-column
            label="是否名企配套产品"
            align="center"
            prop="well_known_used"
            v-if="columns[6].visible"
          />
          <el-table-column
            label="操作"
            align="center"
            class-name="small-padding fixed-width"
            v-if="columns[7].visible"
          >
            <template slot-scope="scope">
              <div class="cursorpointer flex">
                <span style="color: #52c5cb" @click="todetails(scope.row)"
                  >修改</span
                >
                <span
                  style="color: #52c5cb"
                  class="pad-left20"
                  @click="removepro(scope.row)"
                  >删除</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="
            flex-betweennowrap
            pad-top20 pad-bot20
            pagination
            width98
            margin-auto
          "
          v-if="total != 0"
        >
          <span></span>
          <el-pagination
            :hide-on-single-page="true"
            @size-change="handleSizeChange"
            @current-change="currentchange"
            :current-page="currentPage"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="per_page"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>
    <!-- 缩略图 -->
    <el-skeleton
      class="width100 backwhite border-rd3 alldigital margin-top15"
      :loading="true"
      animated
      :throttle="500"
      v-if="picColumn"
    >
      <template slot="template">
        <div
          class="width96 margin-top20 pad-bot20 margin-auto flex-leftwrap"
          v-if="total != 0"
        >
          <div
            v-for="(item, index) in pages"
            :key="index"
            class="margin-right25 margin-top20 margin-bot80"
            style="width: 168px; height: 168px"
          >
            <div
              class="fileboxs border-rd3"
              @mouseover="mouseOver(index)"
              @mouseleave="mouseLeave(index)"
            >
              <div
                v-if="mousechange == index ? true : false"
                class="picturecont cursorpointer"
              >
                <div class="picspan">
                  <span @click="projectpreview(index)">
                    <img src="@/assets/barsvg/icon／14yl.png" alt="" /> </span
                  ><span @click="todetailspic(index)" class="margin-left20">
                    <img src="@/assets/barsvg/icon／14bj.png" alt="" />
                  </span>
                  <span @click="removepropic(index)" class="margin-left20">
                    <img src="@/assets/barsvg/icon／14sc.png" alt="" />
                  </span>
                </div>
              </div>
              <el-image
                :src="
                  item.picture == null || item.picture == ''
                    ? ''
                    : item.picture.indexOf('http') == -1
                    ? picturehead + item.picture
                    : item.picture
                "
                class="pictureimg border-rd3"
              >
                <div slot="error" class="image-slot">
                  <img
                    class="width100"
                    src="@/assets/barsvg/tpjzsb.svg"
                    alt=""
                  />
                </div>
              </el-image>

              <div class="margin-bot10 lineheight30">
                <p class="overhide f14">{{ item.title }}</p>
                <p class="overhide dimencont f12">
                  {{ item.bigcate.name }}-{{ item.cate.name }}
                </p>
              </div>
            </div>
          </div>
          <div
            class="
              flex-betweennowrap
              pad-top20 pad-bot20
              pagination
              width98
              margin-auto
            "
            v-if="total != 0"
          >
            <span></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <!-- 项目预览 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblepro"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="40%"
      class="errorboxs"
    >
      <div class="width100 margin-auto">
        <!-- 检索 -->
        <div class="backwhite">
          <div class="f16 width98 textalign-left dimensional">产品数据预览</div>

          <table class="width100 margin-auto text-ellipsis margin-top40">
            <tr>
              <td class="tdtit">产品名称</td>
              <td class="tdcont">{{ formtitle }}</td>
              <td class="tdtit">立项时间</td>
              <td class="tdcont">{{ formstart_at }}</td>
            </tr>
            <tr>
              <td class="tdtit">产品类别</td>
              <td class="tdcont">{{ formcate_idbig }}__{{ formcate_id }}</td>
              <td class="tdtit">上游产业</td>
              <td class="tdcont">{{ formupsteam }}</td>
            </tr>
            <tr>
              <td class="tdtit">下游产业</td>
              <td class="tdcont">{{ formdownsteam }}</td>
              <td class="tdtit">名企配套</td>
              <td class="tdcont">{{ formwell_known_used }}</td>
            </tr>
            <tr>
              <td class="tdtit">技术关键词</td>
              <td class="tdcont">{{ formtech_keyword }}</td>
              <td class="tdtit">技术垄断者</td>
              <td class="tdcont">{{ formtech_controller }}</td>
            </tr>
            <tr>
              <td class="tdtit">关联竞争对手</td>
              <td class="tdcont">{{ formopponent }}</td>
              <td class="tdtit">关联专利</td>
              <td class="tdcont">{{ formpatent }}</td>
            </tr>
          </table>
          <div class="width100 margin-top20">
            <p class="textalign-left">产品封面</p>
            <div class="textalign-left width20">
              <el-image
                :src="picturehead + formpicture"
                class="width100 hight140 margin-top20"
              >
                <div slot="error" class="image-slot">
                  <img
                    class="pictureimg"
                    src="@/assets/barsvg/tpjzsb.svg"
                    alt=""
                  />
                </div>
              </el-image>
            </div>
          </div>
          <div class="width100">
            <p class="textalign-left margin-top20">附件</p>
            <div class="margin-auto flex-leftwrap margin-top20">
              <div
                v-for="(item, index) in filebox"
                :key="index"
                class="width20"
              >
                <div class="filebox">
                  <el-image
                    :src="picturehead + item.url"
                    class="width100 hight140 border-rd3"
                  ></el-image>
                  <div class="margin-bot10 f12">
                    <p class="text-ellipsis textalign-left">
                      {{ item.original_name }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="width100">
            <p class="textalign-left margin-top20">产品详情</p>
            <div
              class="textalign-left margin-top20 lineheight30"
              style="color: #969eac"
              v-html="formremark"
            ></div>
          </div>

          <div class="textalign-right">
            <el-button @click="dialogVisiblepro = false">取 消</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="open" append-to-body width="40%">
      <el-transfer
        :titles="['全选', '全选']"
        v-model="value"
        :data="columns"
        @change="dataChange"
      ></el-transfer>
    </el-dialog>
  </div>
</template>
 <script>
import { entproductindex, entproductdelete } from "@/api/Center/Center.api";
import BUS from "@/BUS/BUS";
import callback from "@/components/callback.vue";
import { entproductdetail, entproductcate } from "@/api/Center/Center.api";
import switchcore from "@/components/switchcore.vue";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      listColumn: false,
      picColumn: true,
      loading: true,
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false,
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisiblepro: false,
      mentSuccess: true,
      serchkey: true,
      ruleForm: {
        pipo: "",
        name: "",
      },
      thisNum: 1,
      pages: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      input: "",
      inputs: "",
      formtitle: "",
      formstart_at: "",
      formupsteam: "",
      formcate_id: "",
      formcate_idbig: "",
      formdownsteam: "",
      formwell_known_used: "",
      formtech_keyword: "",
      formpatent: "",
      formopponent: "",
      formtech_controller: "",
      formremark: "",
      formpicture: "",
      formpictureurl: "",
      mousechange: -1,
      mousechanges: -1,
      filebox: [],
      picturehead: "",
      optionb: [],
      optionm: [],
      page: {},
      rowid: "",
      columns: false,
      isClear: false, //设置为true的时候，这个可以用this.wangEditorDetail=''来替代
      wangEditorDetail: "",
      files: [],
    };
  },

  props: {
    showSearch: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    callback,
    switchcore,
  },
  methods: {
    changelistColumn() {
      this.picColumn = true;
      this.listColumn = false;
      this.columns = false;
    },
    changepicColumn() {
      this.listColumn = true;
      this.picColumn = false;
      this.columns = [
        { key: 0, label: `产品名称`, visible: true },
        { key: 1, label: `产品大类`, visible: true },
        { key: 2, label: `产品小类`, visible: true },
        { key: 3, label: `技术关键词`, visible: true },
        { key: 4, label: `研发立项时间`, visible: true },
        { key: 5, label: `上游产业`, visible: true },
        { key: 6, label: `是否名企配套产品`, visible: true },
        { key: 7, label: `操作`, visible: true },
      ];
    },
    // 新增
    dialogVisibleaddpro() {
      this.$router.push({
        path: "/development-Administration/product-addfication",
      });
    },

    // 移入
    mouseOver(index) {
      this.mousechange = index;
    },
    // 移出
    mouseLeave(index) {
      this.mousechange = -1;
    },
    // 移入
    mouseOvers(index) {
      this.mousechanges = index;
    },
    // 移出
    mouseLeaves(index) {
      this.mousechanges = -1;
    },
    // 右侧列表元素变化
    dataChange(data) {
      for (let item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    },
    refresh() {
      this.$loading.show(); // 显示loading
      // 获取产品列表
      entproductindex({
        page: this.thisNum,
        limit: 20,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.pages.forEach((i) => {
            if (i.well_known_used == 1) {
              i.well_known_used = "是";
            } else {
              i.well_known_used = "否";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 获取产品类别
    optionbchange(value) {
      this.form.cate_id = "";
      entproductcate({
        parent_id: value,
      }).then((res) => {
        if (res.data.code == 200) {
          this.optionm = res.data.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 删除
    removepro(row) {
      this.$confirm("此操作将删除此产品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entproductdelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 删除
    removepropic(index) {
      this.$confirm("此操作将删除此产品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entproductdelete({ id: this.pages[index].id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 修改按钮
    todetails(row) {
      BUS.$emit("promanageid", row.id);
      window.sessionStorage.setItem("promanageid", row.id);
      this.$router.push({
        path: "/development-Administration/product-modification",
      });
    },
    // 修改按钮
    todetailspic(index) {
      BUS.$emit("promanageid", this.pages[index].id);
      window.sessionStorage.setItem("promanageid", this.pages[index].id);
      this.$router.push({
        path: "/development-Administration/product-modification",
      });
    },
    // 项目预览
    projectpreview(index) {
      this.dialogVisiblepro = true;
      entproductdetail({
        id: this.pages[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.formtitle = res.data.data.title;
          this.formstart_at = res.data.data.start_at;
          this.formupsteam = res.data.data.upsteam;
          this.formcate_id = res.data.data.cate.name;
          this.formcate_idbig = res.data.data.bigcate.name;
          this.formdownsteam = res.data.data.downsteam;
          // this.formwell_known_used = res.data.data.well_known_used;
          this.formtech_keyword = res.data.data.tech_keyword;
          this.formpatent = res.data.data.patent;
          this.formopponent = res.data.data.opponent;
          this.formtech_controller = res.data.data.tech_controller;
          this.formremark = res.data.data.remark;

          this.formpictureurl = res.data.data.picture;
          this.formpicture = res.data.data.picture;
          this.filebox = res.data.data.files;
          this.page = res.data.data;
          if (res.data.data.well_known_used == 0) {
            this.formwell_known_used = "否";
          } else {
            this.formwell_known_used = "是";
          }
          this.filebox = res.data.data.files;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    projectpreviews(row) {
      this.dialogVisiblepro = true;
      entproductdetail({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.formtitle = res.data.data.title;
          this.formstart_at = res.data.data.start_at;
          this.formupsteam = res.data.data.upsteam;
          this.formcate_id = res.data.data.cate.name;
          this.formcate_idbig = res.data.data.bigcate.name;
          this.formdownsteam = res.data.data.downsteam;
          // this.formwell_known_used = res.data.data.well_known_used;
          this.formtech_keyword = res.data.data.tech_keyword;
          this.formpatent = res.data.data.patent;
          this.formopponent = res.data.data.opponent;
          this.formtech_controller = res.data.data.tech_controller;
          this.formremark = res.data.data.remark;

          this.formpictureurl = res.data.data.picture;
          this.formpicture = res.data.data.picture;
          this.filebox = res.data.data.files;
          this.page = res.data.data;
          if (res.data.data.well_known_used == 0) {
            this.formwell_known_used = "否";
          } else {
            this.formwell_known_used = "是";
          }
          this.filebox = res.data.data.files;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 第一个分页
    currentchange(val) {
      entproductindex({
        page: val,
        limit: 20,
        _keywords: this.input,
        tech_keyword: this.inputs,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.pages.forEach((i) => {
            if (i.well_known_used == 1) {
              i.well_known_used = "是";
            } else {
              i.well_known_used = "否";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      entproductindex({
        page: 1,
        limit: val,
        _keywords: this.input,
        tech_keyword: this.inputs,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.pages.forEach((i) => {
            if (i.well_known_used == 1) {
              i.well_known_used = "是";
            } else {
              i.well_known_used = "否";
            }
          });
          this.total = res.data.data.total;
          this.per_page = Number(res.data.data.per_page);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置
    resetForm() {
      this.input = null;
      this.inputs = null;
      entproductindex({
        page: 1,
        limit: 20,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.pages.forEach((i) => {
            if (i.well_known_used == 1) {
              i.well_known_used = "是";
            } else {
              i.well_known_used = "否";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 检索
    submitForm() {
      entproductindex({
        _keywords: this.input,
        tech_keyword: this.inputs,
        limit: 20,
        page: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.pages.forEach((i) => {
            if (i.well_known_used == 1) {
              i.well_known_used = "是";
            } else {
              i.well_known_used = "否";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    this.Apisrcone = window.g.ApiUrl + "/oss_form";
    this.Apisrc = window.g.ApiUrl + "/ent_product/uploader";
    this.picturehead = window.g.Apisrc;
    // 显隐列初始默认隐藏列
    for (let item in this.columns) {
      if (this.columns[item].visible === false) {
        this.value.push(parseInt(item));
      }
    }
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });
    // 获取产品列表
    entproductindex({
      page: this.thisNum,
      limit: 20,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pages = res.data.data.data;
        this.pages.forEach((i) => {
          if (i.well_known_used == 1) {
            i.well_known_used = "是";
          } else {
            i.well_known_used = "否";
          }
        });
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("promanage", (data) => {
      if (data == 1) {
        this.refresh();
      }
    });
  },
};
</script>
<style scoped>
table {
  border-collapse: collapse;
}
tr {
  width: 100%;
}
td {
  border: 1px solid #f0f0f0;
}
.tdtit {
  width: 15%;
  height: 40px;
  background: #f1f3f9;
  border: 1px solid rgba(233, 233, 233, 1);
  padding-left: 10px;
  font-size: 14px;
  color: #6a7589;
}
.tdcont {
  width: 35%;
  padding-left: 10px;
  height: 40px;
  font-size: 14px;
  color: #353a44;
}

::v-deep .el-transfer__button {
  border-radius: 50%;
  padding: 12px;
  display: block;
  margin-left: 0px;
}
::v-deep .el-transfer-panel {
  width: 250px;
}
::v-deep .el-transfer__button:first-child {
  margin-bottom: 10px;
}
.preservation {
  background: #409eff;
  color: white;
  width: 80px;
  text-align: center;
  border-radius: 5px;
  line-height: 30px;
  float: right;
}
.filebox {
  width: 90%;
  height: 140px;
  margin: 0 0 40px 0;
  position: relative;
}
.fileboxs {
  width: 90%;
  height: 160px;
  margin: 0 0 20px 0;
  position: relative;
}
.pictureimg {
  width: 100%;
  height: 168px;
}

.picturecont {
  width: 100%;
  height: 168px;
  background-color: rgb(85 0 0 / 46%);
  position: absolute;
  text-align: center;
  color: white;
  z-index: 2;
}
.picspan {
  position: relative;
  top: 50%;
  z-index: 3;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 110px;
  height: 110px;
  line-height: 110px;
  position: relative;
  right: 140px;
}
.avatar {
  width: 110px;
  height: 110px;
  display: block;
}

.pictureconts {
  width: 100%;
  height: 100%;
  background-color: rgb(85 0 0 / 46%);
  position: absolute;
  text-align: center;
  color: white;
  z-index: 2;
}
.pictureimgs {
  width: 100%;
  height: 120px;
}
.fileboxs {
  width: 100%;
  height: 120px;
  margin: 0 0 50px 0;
  position: relative;
}
.picspans {
  position: relative;
  top: 40%;
  z-index: 3;
}
.uploaddragger >>> .el-upload {
  width: 100%;
}
.uploaddragger >>> .el-upload-dragger {
  width: 100%;
  margin: auto;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 13px;
}
.editor >>> .el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>